import { CheckoutReviewOrderInfoApplicationEvent 
} from '~shared/modules/application-event/models/checkout-review-order-info-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventType } from '../../constants';
export class GaTrackingAddReviewInfoEventModel implements GATrackingEvent{
  constructor(private checkoutReviewOrderInfoApplicationEventPayload: CheckoutReviewOrderInfoApplicationEvent) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ReviewOrderInfo;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.getEventType(),
      gtmCustom: {
        ...this.checkoutReviewOrderInfoApplicationEventPayload,
        payment_method: this.checkoutReviewOrderInfoApplicationEventPayload.payment_method
      }
    };
  }
}
